export const DATE_FORMAT = 'yyyy-MM-dd';
